import { BaseKeyRLetter, DefinitionNode } from "./artseyMap";

export const artseyRight: DefinitionNode<BaseKeyRLetter> = {
  j: {
    end: "a",
    then: {
      k: {
        end: "f",
        then: {
          l: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ";": {
        end: "w",
        then: {
          l: {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
          k: {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ",": {
        end: ".",
        then: {
          ".": {
            end: ",",
            then: {},
          },
        },
      },
      ".": {
        end: ",",
        then: {
          ",": {
            end: ",",
            then: {},
          },
        },
      },
      "/": {
        end: "/",
        then: {},
      },
      m: {
        end: "Enter",
        then: {},
      },
      l: {
        then: {
          k: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
    },
  },
  k: {
    end: "r",
    then: {
      j: {
        end: "f",
        then: {
          l: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      l: {
        end: "g",
        then: {
          j: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ";": {
        end: "v",
        then: {
          l: {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
          j: {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ".": {
        end: "Del",
        then: {},
      },
      m: {
        end: "Backspace",
        then: {},
      },
    },
  },
  l: {
    end: "t",
    then: {
      k: {
        end: "g",
        then: {
          j: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ";": {
        end: "j",
        then: {
          j: {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
          k: {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      ".": {
        end: "!",
        then: {},
      },
      j: {
        then: {
          k: {
            end: "d",
            then: {
              ";": {
                end: "z",
                then: {},
              },
            },
          },
          ";": {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
    },
  },
  ";": {
    end: "s",
    then: {
      k: {
        end: "v",
        then: {
          l: {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
          j: {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      l: {
        end: "j",
        then: {
          j: {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
          k: {
            end: "x",
            then: {
              j: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
      j: {
        end: "w",
        then: {
          l: {
            end: "q",
            then: {
              k: {
                end: "z",
                then: {},
              },
            },
          },
          k: {
            then: {
              l: {
                end: "z",
                then: {},
              },
            },
          },
        },
      },
    },
  },
  m: {
    end: "e",
    then: {
      "/": {
        end: "b",
        then: {
          ".": {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
          ",": {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ",": {
        end: "c",
        then: {
          ".": {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
          "/": {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ".": {
        end: "h",
        then: {
          "/": {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
          ",": {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      k: {
        end: "Backspace",
        then: {},
      },
      j: {
        end: "Enter",
        then: {},
      },
    },
  },
  ",": {
    end: "y",
    then: {
      m: {
        end: "c",
        then: {
          ".": {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
          "/": {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ".": {
        end: "u",
        then: {
          "/": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
          j: {
            end: ",",
            then: {},
          },
        },
      },
      "/": {
        end: "k",
        then: {
          ".": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      j: {
        end: ".",
        then: {
          ".": {
            end: ",",
            then: {},
          },
        },
      },
    },
  },
  ".": {
    end: "i",
    then: {
      "/": {
        end: "n",
        then: {
          ",": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ",": {
        end: "u",
        then: {
          "/": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
          j: {
            end: ",",
            then: {},
          },
        },
      },
      m: {
        end: "h",
        then: {
          "/": {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
          ",": {
            end: "l",
            then: {
              "/": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      j: {
        end: ",",
        then: {
          ",": {
            end: ",",
            then: {},
          },
        },
      },
      l: {
        end: "!",
        then: {},
      },
      k: {
        end: "Del",
        then: {},
      },
    },
  },
  "/": {
    end: "o",
    then: {
      m: {
        end: "b",
        then: {
          ".": {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
          ",": {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ".": {
        end: "n",
        then: {
          ",": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            end: "p",
            then: {
              ",": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      ",": {
        end: "k",
        then: {
          ".": {
            end: "m",
            then: {
              m: {
                end: " ",
                then: {},
              },
            },
          },
          m: {
            then: {
              ".": {
                end: " ",
                then: {},
              },
            },
          },
        },
      },
      j: {
        end: "/",
        then: {},
      },
    },
  },
};
